var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.293,
    height: 25.5,
    viewBox: "0 0 25.293 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(-1.584 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72157",
    "data-name": "Group 72157",
    transform: "translate(2.334 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91696",
    "data-name": "Path 91696",
    d: "M19.769,22.558H8.692m11.077,0a3.692,3.692,0,0,1,3.692,3.692H5a3.692,3.692,0,0,1,3.692-3.692m11.077,0V18.4a1.384,1.384,0,0,0-1.385-1.385H17.312m-8.62,5.538V18.4a1.385,1.385,0,0,1,1.385-1.385H11.15m6.162,0H11.15m6.162,0a9.174,9.174,0,0,1-1.209-3.9m-4.954,3.9a9.174,9.174,0,0,0,1.207-3.9M5.923,4.694q-1.813.264-3.589.64a7.388,7.388,0,0,0,6.641,6.119M5.923,4.694v.325a8.29,8.29,0,0,0,3.052,6.434M5.923,4.694V2.83a59.882,59.882,0,0,1,16.615,0V4.694M8.975,11.454a8.278,8.278,0,0,0,3.382,1.662M22.538,4.694v.325a8.29,8.29,0,0,1-3.052,6.434m3.052-6.759q1.8.263,3.589.64a7.388,7.388,0,0,1-6.64,6.119m0,0A8.278,8.278,0,0,1,16.1,13.115m0,0a8.335,8.335,0,0,1-3.746,0",
    transform: "translate(-2.334 -2.25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.4c101f74fcf62ad3c9f771dd96b02983.svg";
export { ForwardRef as ReactComponent };